import store from '@/store'

export default {
    data() {
        return {
            shared: store
        }
    },

    methods: {
        hasPermission(permissionName) {
            return this.shared.user.permissions.some(permission => permission.name === permissionName)
        },

        missingPermission(permissionName) {
            return !this.hasPermission(permissionName)
        }
    }
}
